import { combineReducers } from 'redux';
import { reducer as userCenter } from '@xgimi-private/user-center';

import common from './common';
import user from './user';

export default combineReducers({
  userCenter,
  common,
  user,
});
